// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2$Linear from "./V2.res.js";

function map(param, f) {
  return {
    pos: V2$Linear.map(param.pos, f),
    size: V2$Linear.map(param.size, f)
  };
}

function jsonCodec(elementCodec) {
  return Jzon.object2(param => [
    param.pos,
    param.size
  ], param => ({
    TAG: "Ok",
    _0: {
      pos: param[0],
      size: param[1]
    }
  }), Jzon.field("pos", V2$Linear.jsonCodec(elementCodec)), Jzon.field("size", V2$Linear.jsonCodec(elementCodec)));
}

export {
  map,
  jsonCodec,
}
/* No side effect */
